import AddIcon from '@mui/icons-material/Add';
import { TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import toast from 'react-hot-toast';
import './CompanyTypeList.css';

import CustomButton from '../../../components/UI/CustomButton';
import { deleteCompanyType, getCompanyType } from '../../../services/Service';
import AddCompanyTypeModal from './AddCompanyTypeModal';
import DeleteConfirmationModal from './DeleteConfirmationModal';
import DownloadMenuBusiness from './DownloadMenuBusiness';
import FilterMenu from './FilterMenu';
import TableView from './TableView';

const CompanyTypeList = () => {
  const [addModalOpen, setAddModalOpen] = useState({
    open: false,
    data: null,
  });
  const [rawData, setRawData] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [rawDataFilter, setRawDataFilter] = useState([]);
  const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState({
    open: false,
    data: null,
  });

  const [filter, setFilter] = useState({
    orderBy: 'createdAt',
    order: 'desc',
    status: '',
  });

  const fetchData = async () => {
    try {
      const res = await getCompanyType();
      if (res.status === 200) {
        setRawData(res.data.data);
        setRawDataFilter(res.data.data);
      }
    } catch (err) {
      console.log('getCompanyType fetchData error', err.message);
    }
  };

  const onAddModalOpen = () => {
    setAddModalOpen({
      open: true,
      data: null,
    });
  };

  const onAddModalOpenEdit = (data) => {
    setAddModalOpen({
      open: true,
      data: data,
    });
  };

  const onAddModalClose = () => {
    setAddModalOpen({
      open: false,
      data: null,
    });
    fetchData();
  };

  const onDelete = async (data) => {
    try {
      const res = await deleteCompanyType(data._id);
      if (res.status === 200) {
        toast.success(res.data.message);
        onDeleteModalReset();
        fetchData();
      }
    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  const onDeleteModalReset = () => {
    setIsDeleteConfirmationModalOpen({
      open: false,
      data: null,
    });
  };

  const onSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    // setFilter((prev) => ({ ...prev, search: value }));
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSort = (sortObj) => {
    setFilter((prev) => ({ ...prev, orderBy: sortObj.orderBy, order: sortObj?.order ?? '' }));
  };

  const onFilterReset = () => {
    setFilter((prev) => ({ ...prev, status: '' }));
  };
  const onFilterApply = (newFilterState) => {
    if (newFilterState?.status !== '') setFilter((prev) => ({ ...prev, status: newFilterState.status }));

    let newData = [...rawData];
    if (newFilterState.status) {
      newData = newData.filter((ex) => ex?.isOffer === (newFilterState.status === 'Active'));
    }
    setRawDataFilter(newData);
  };

  return (
    <>
      <Helmet>
        <title>Company Type List - SafalSubscriptions</title>
      </Helmet>

      <div id="CompanyTypeList">
        <div className="title-bar">
          <div className="title-search-div">
            <Typography variant="h4" sx={{ fontSize: '40px', fontWeight: 700, color: '#027c34' }}>
              Company Type List
            </Typography>
          </div>
        </div>
        <div className="toggle-bar">
          <div className="toggle-bar-dix">
            <TextField
              sx={{ width: '200px', ml: '12px' }}
              onChange={onSearchChange}
              value={searchValue}
              type="search"
              id="search-input"
              size="small"
              label="Search"
              variant="outlined"
            />
          </div>
          <div className="title-action-div">
            <DownloadMenuBusiness data={rawData} />
            <FilterMenu filterState={filter} onFilterReset={onFilterReset} onFilterApply={onFilterApply} />
            <CustomButton backgroundColor="#027c34" text="Add New" icon={<AddIcon />} onClick={onAddModalOpen} />
          </div>
        </div>
        <TableView
          onDelete={(data) => {
            setIsDeleteConfirmationModalOpen({
              open: true,
              data,
            });
          }}
          onEdit={onAddModalOpenEdit}
          data={rawDataFilter}
          onSort={onSort}
        />
      </div>
      <DeleteConfirmationModal
        open={isDeleteConfirmationModalOpen.open}
        onClose={onDeleteModalReset}
        data={isDeleteConfirmationModalOpen.data}
        onSubmit={onDelete}
      />
      <AddCompanyTypeModal open={addModalOpen.open} data={addModalOpen.data} onClose={onAddModalClose} />
    </>
  );
};

export default CompanyTypeList;
